var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import Inline from 'syf-component-library/ui/spacing/Inline';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateUserAnswers } from '../../../../redux/userAnswers/userAnswers.slice';
import formatUserAnswer from '../../../../helpers/formatUserAnswer';
import determineCheckedAnswer from '../../../../helpers/determineCheckedAnswer';
import { clearFormError } from '../../../../redux/ui/ui.slice';
import getCurrentQuestionAnswer from '../../../../helpers/getCurrentQuestionAnswer';
import AdditionalContent from '../../../../ui/atoms/AdditionalContent';
import strings from '../../../../strings/i18n/englishTranslations';
import defaultTheme from '../../../../theme';
import { Chip, Icon, Wrapper } from './subcomponents';
var hoverBlue = defaultTheme.colors.hoverBlue;
var OptionList = function (_a) {
    var answerOptions = _a.answerOptions;
    var _b = useSelector(function (state) { return state; }, shallowEqual), formError = _b.ui.formError, userAnswers = _b.userAnswers, currentQuestion = _b.questionnaire.currentQuestion;
    var dispatch = useDispatch();
    var optionRef = useRef(null);
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var checkedAnswer = determineCheckedAnswer({
        currentQuestion: currentQuestion,
        currentQuestionAnswer: currentQuestionAnswer
    });
    var selectedAnswer = answerOptions.find(function (item) { return item.answerOption === checkedAnswer; });
    var hasAdditionalContent = selectedAnswer === null || selectedAnswer === void 0 ? void 0 : selectedAnswer.additionalContent;
    var handleOnClick = function (option, nextQuestionId, answerId, disputeReason, script) {
        dispatch(clearFormError());
        var userAnswer = formatUserAnswer({
            nextQuestionId: nextQuestionId,
            answerId: answerId,
            option: [option],
            currentQuestion: currentQuestion,
            disputeReason: disputeReason,
            script: script
        });
        dispatch(updateUserAnswers(userAnswer));
    };
    var chipOptions = answerOptions.map(function (_a, index) {
        var nextQuestionId = _a.nextQuestionId, answerId = _a.answerId, answerOption = _a.answerOption, disputeReason = _a.disputeReason, script = _a.script;
        var chipKey = index + nextQuestionId;
        return (_jsxs("div", { children: [_jsx(Chip, __assign({ hasError: !(checkedAnswer && hasAdditionalContent) && !!formError, id: answerOption, iconLeft: true, icon: answerOption === checkedAnswer && (_jsx(Icon, { name: "faCheck", size: "1x" })), onClick: function () {
                        return handleOnClick(answerOption, nextQuestionId, answerId, disputeReason, script);
                    }, css: answerOption === checkedAnswer && "background-color:".concat(hoverBlue, " "), tabIndex: 0, role: "radio", "aria-checked": answerOption === checkedAnswer, onKeyPress: function (e) {
                        return (e.key === 'Enter' || e.key === ' ') &&
                            handleOnClick(answerOption, nextQuestionId, answerId, disputeReason, script);
                    } }, { children: answerOption })), _jsx(Inline, { size: "large" })] }, chipKey));
    });
    useEffect(function () {
        if (formError === strings.translation.formError.pleaseSelect) {
            optionRef.current.focus();
        }
    }, [formError]);
    return (_jsxs(_Fragment, { children: [_jsx(Wrapper, __assign({ ref: optionRef, tabIndex: -1, role: "radiogroup", "aria-labelledby": "disputes-label", "aria-invalid": !!formError, "aria-required": "true" }, { children: chipOptions })), hasAdditionalContent && (_jsx(AdditionalContent, { answerMetadata: selectedAnswer.metadata }))] }));
};
export default OptionList;
//# sourceMappingURL=index.js.map